import type { CaixaTipoMovimentacao } from "./types/types";

type TipoKind = "entrada" | "saida" | "neutro";

interface TipoMeta {
  label: string;
  kind: TipoKind;
}

const TIPO_META: Record<CaixaTipoMovimentacao, TipoMeta> = {
  DEPOSITO_MANUAL: { label: "Depósito", kind: "entrada" },
  SANGRIA: { label: "Sangria", kind: "entrada" },
  FECHAMENTO_CAIXA: { label: "Fechamento de caixa", kind: "entrada" },
  RETIRADA_MANUAL: { label: "Retirada", kind: "saida" },
  ABERTURA_CAIXA: { label: "Abertura de caixa", kind: "saida" },
  EDICAO_COFRE: { label: "Edição valor no cofre", kind: "neutro" },
};

/**
 * Resolve o tipo detalhado da movimentação. Registros antigos sem
 * `tipo_movimentacao` caem no fallback pelo sinal do valor.
 */
export const resolveTipoMovimentacao = (row?: {
  tipo_movimentacao?: CaixaTipoMovimentacao | null;
  valor_movimentacao?: number | null;
}): TipoMeta => {
  const tipo = row?.tipo_movimentacao;
  if (tipo && TIPO_META[tipo]) {
    return TIPO_META[tipo];
  }
  return Number(row?.valor_movimentacao || 0) < 0
    ? TIPO_META.RETIRADA_MANUAL
    : TIPO_META.DEPOSITO_MANUAL;
};

export const TIPO_BADGE_CLASS: Record<TipoKind, string> = {
  entrada: "bg-emerald-50 text-emerald-700",
  saida: "bg-red-50 text-red-600",
  neutro: "bg-gray-100 text-gray-600",
};
